import { render, staticRenderFns } from "./dr-iframe.vue?vue&type=template&id=07bf8367&"
import script from "./dr-iframe.vue?vue&type=script&lang=js&"
export * from "./dr-iframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports